<template>
    <div class="clearfix" v-if="links.last_page && links.last_page > 1">
        <div class="float-left fs-14">Записи с {{links.from}} до {{links.to}} из {{links.total}} записей</div>
        <nav class="float-right" aria-label="">
            <ul class="pagination">
                <li class="page-item page-arrow">
                    <router-link v-if="links.current_page > 1" :to="'/' + url + '/' + (links.current_page - 1)" class="page-link" aria-label="Next">
                        <i aria-hidden="true" class="mdi mdi-chevron-left"></i>
                    </router-link>
                    <span class="page-link-disabled" v-else>
                        <i aria-hidden="true" class="mdi mdi-chevron-left"></i>
                    </span>
                </li>
                <li class="page-item" v-for="link in this.pageRange" :class="{'active': (links.current_page === link)}">
                    <router-link :to="'/' + url + '/' + link" class="page-link" v-if="links.current_page !== link && link !== '...'">{{ link }}</router-link>
                    <span class="page-link-disabled" v-else-if="link === '...'">{{ link }}</span>
                    <span class="page-link" v-else>{{ link }}</span>
                </li>

                <li class="page-item page-arrow">
                    <router-link v-if="links.current_page < links.last_page" :to="'/' + url + '/' + (links.current_page + 1)" class="page-link" aria-label="Next">
                        <i aria-hidden="true" class="mdi mdi-chevron-right"></i>
                    </router-link>
                    <span class="page-link-disabled" v-else>
                        <i aria-hidden="true" class="mdi mdi-chevron-right"></i>
                    </span>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'pagination',
        props: {
            links: {
                type: Object,
                required: true
            },
            url: {
                type: String,
                required: true,
            },
            pagination_count: 5,
        },
        methods: {},
        computed: {
            pageRange() {
                let delta = 2;
                const range = Array(this.links.last_page).fill().map((_, index) => index + 1);
                return range.reduce((pages, page) => {
                    if (page === 1 || page === this.links.last_page) return [...pages, page];
                    if (page - delta <= this.links.current_page && page + delta >= this.links.current_page) return [...pages, page];
                    if (pages[pages.length - 1] !== '...') return [...pages, '...'];
                    return pages;
                }, []);
            }
        }
    }
</script>

<style scoped>
    .page-link-disabled {
        position: relative;
        display: block;
        margin-left: -1px;
        line-height: 1.25;
        background-color: #fff;
        border: 1px solid #dee2e6;
        padding: 5px 10px;
        border-radius: 4px;
        color: #354052;
        font-size: 14px;
    }

</style>
